import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
export const ActionSheetSeparator = /*#__PURE__*/ memo((param)=>{
    let { className, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx("hr", {
        className: tailwindMerge("-mx-2 h-px border-0 bg-grey-4", className),
        ...restOfProps
    });
});
ActionSheetSeparator.displayName = "ActionSheetSeparator";
